import styled, { css } from "styled-components";

export const GamificationInfosContainer = styled.div<{
  coinsColor: string;
  shouldWarminUp: boolean;
}>`
  display: flex;
  gap: 0.875rem;

  @keyframes warmingUpCoins {
    0% {
      background-color: ${({ coinsColor }) => coinsColor}59;
    }
    50% {
      background-color: ${({ coinsColor }) => coinsColor}33;
    }
    100% {
      background-color: ${({ coinsColor }) => coinsColor}59;
    }
  }

  .coins-section {
    .coins {
      ${({ shouldWarminUp }) =>
        shouldWarminUp &&
        css`
          cursor: pointer;
          animation-name: warmingUpCoins;
          animation-duration: 2s;
          animation-iteration-count: infinite;
        `}

      background-color: ${({ coinsColor }) => coinsColor}59;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.25rem;
      border-radius: 4px;
      width: 100%;

      padding: 0.5rem;

      p {
        color: ${({ theme }) => theme.groups.primaryText};
        font: 500 0.75rem/0.938rem "Inter";
        margin: 0;
        width: auto;
      }

      svg,
      * {
        width: 0.813rem;
        max-height: 0.813rem;
        fill: ${({ coinsColor }) => coinsColor};
      }
    }

    .gained-coins {
      position: absolute;

      background-color: ${({ coinsColor }) => coinsColor}40;

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.25rem;
      border-radius: 4px;
      width: fit-content;

      padding: 0.125rem 0.25rem;

      p {
        color: ${({ theme }) => theme.groups.primaryText};
        font: 500 0.688rem/0.938rem "Inter";
        margin: 0;
        width: auto;
      }

      svg,
      * {
        width: 0.813rem;
        max-height: 0.813rem;
        fill: ${({ coinsColor }) => coinsColor};
      }
    }
  }

  @keyframes warmingUpExp {
    0% {
      background-color: ${({ theme }) =>
        theme.colors.globalTopbar.gamificationExpBackground};
    }
    50% {
      background-color: ${({ theme }) =>
        theme.colors.globalTopbar.gamificationExpBackgroundHover};
    }
    100% {
      background-color: ${({ theme }) =>
        theme.colors.globalTopbar.gamificationExpBackground};
    }
  }

  .exp-section {
    .exp {
      ${({ shouldWarminUp }) =>
        shouldWarminUp &&
        css`
          cursor: pointer;
          animation-name: warmingUpExp;
          animation-duration: 2s;
          animation-iteration-count: infinite;
        `}
      background-color: ${({ theme }) =>
        theme.colors.globalTopbar.gamificationExpBackground};

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.25rem;
      border-radius: 4px;
      width: 100%;

      padding: 0.5rem;

      p {
        color: ${({ theme }) =>
          theme.colors.globalTopbar.gamificationExpTextColor};
        font: 500 0.75rem/0.938rem "Inter";
        margin: 0;
        width: auto;
      }

      svg,
      * {
        width: 0.813rem;
        max-height: 0.813rem;
      }
    }

    .gained-exp {
      position: absolute;

      background-color: ${({ theme }) =>
        theme.colors.globalTopbar.gamificationExpBackground};

      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.25rem;
      border-radius: 4px;
      width: fit-content;

      padding: 0.125rem 0.25rem;

      p {
        color: ${({ theme }) =>
          theme.colors.globalTopbar.gamificationExpTextColor};
        font: 500 0.688rem/0.938rem "Inter";
        margin: 0;
        width: auto;
      }

      svg,
      * {
        width: 0.625rem;
      }
    }
  }
`;
